// @ts-strict-ignore
import { CmsApiFourArticlesHighlightBlockData } from 'modules/cms/api/types/CmsApiFourArticlesHighlight';
import { CmsAmpCardsBlock } from 'modules/cms/blocks/Amp/Cards';
import { CmsAmpBlockMappingComponentProps } from 'modules/cms/blocks/CmsBlockMapping';

export function CmsAmpFourArticlesHighlightBlock({
  content,
  blockId,
  data,
}: CmsAmpBlockMappingComponentProps<CmsApiFourArticlesHighlightBlockData>) {
  return (
    <CmsAmpCardsBlock
      content={content}
      blockId={blockId}
      data={{
        ...data,
        headline: data.headline,
        cards: ['One', 'Two', 'Three', 'Four']
          .filter((page) => data[`page${page}`])
          .map((page) => ({
            image: data[`page${page}`].image,
            headline: data[`page${page}`].title,
            url: data[`page${page}`].url,
          })),
        maxLength: 4,
      }}
    />
  );
}
